import {
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_RANKING,
} from 'data/nodeTypes';
import { OutcomeActionType } from 'utils/adl-services';
import { LOGIC_MODES } from 'containers/QuestionnairePage/constants';

export const outcomeActionTypes = {
  [LOGIC_MODES.HIDDEN_VARIABLES]: OutcomeActionType.Set,
  [LOGIC_MODES.DISPLAY_LOGIC]: OutcomeActionType.Show,
};

export const supportsTargeIdOnDefaultOutcome = [LOGIC_MODES.DISPLAY_LOGIC];
export const supportsValueTypeOnAction = [LOGIC_MODES.DISPLAY_LOGIC];
export const supportsMultipleValuePerAction = [
  QUESTION_SINGLE,
  QUESTION_MULTIPLE,
  QUESTION_RANKING,
];
